// src/components/operations/TabNavigation.jsx
import {
    QueueListIcon,
    CubeTransparentIcon,
    CalendarDaysIcon,
} from '@heroicons/react/24/outline';

const tabs = [
    { key: 'jobs', label: 'JOBS', icon: QueueListIcon },
    { key: 'workflows', label: 'WORKFLOWS', icon: CubeTransparentIcon },
    { key: 'scheduled', label: 'SCHEDULED', icon: CalendarDaysIcon },
];

const TabNavigation = ({ activeTab, onChange, stats = {} }) => {
    return (
        <div className="flex border-b border-slate-200">
            {tabs.map(tab => {
                const count = stats[tab.key] || 0;
                const Icon = tab.icon;
                const isActive = activeTab === tab.key;

                return (
                    <button
                        key={tab.key}
                        onClick={() => onChange(tab.key)}
                        className={`px-4 py-3 font-mono text-xs font-bold uppercase border-b-2 transition-all duration-150 flex items-center gap-2 ${
                            isActive
                                ? 'border-primary text-primary-dark bg-primary/10'
                                : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50'
                        }`}
                    >
                        <Icon className="h-4 w-4" />
                        {tab.label}
                        {count > 0 && (
                            <span className={`px-1.5 py-0.5 rounded text-xs font-bold ${
                                isActive ? 'bg-primary text-on-accent' : 'bg-slate-100 text-slate-600'
                            }`}>
                                {count}
                            </span>
                        )}
                    </button>
                );
            })}
        </div>
    );
};

export default TabNavigation;
